import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import HeroSection from "@/pages/about-us/sections/HeroSection";
import MissionStatementSection from "@/pages/about-us/sections/MissionStatementSection";
import WhyOurCompanySection from "@/pages/about-us/sections/WhyOurCompanySection";
import ReturnBannerSection from "@/pages/about-us/sections/ReturnBannerSection";
import PartnersSection from "@/pages/about-us/sections/PartnersSection";
import AwardsSection from "@/pages/about-us/sections/AwardsSection";
import DownloadAppSection from "@/pages/about-us/sections/DownloadAppSection";
import AreaOfSupportSection from "@/pages/about-us/sections/AreaOfSupportSection";
var AboutUsPage = function AboutUsPage() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    authenticationMsg: true,
    mainClass: "aboutUs",
    linksForSearch: true,
    hasMobFooter: true
  }, /*#__PURE__*/React.createElement(HeroSection, null), /*#__PURE__*/React.createElement(MissionStatementSection, null), /*#__PURE__*/React.createElement(WhyOurCompanySection, null), /*#__PURE__*/React.createElement(ReturnBannerSection, null), /*#__PURE__*/React.createElement(AreaOfSupportSection, null), /*#__PURE__*/React.createElement(PartnersSection, null), /*#__PURE__*/React.createElement(AwardsSection, null), /*#__PURE__*/React.createElement(DownloadAppSection, null)));
};
export default AboutUsPage;